import bwipjs from "bwip-js";
import {PortalBarcodeFormat} from "../models/PortalAddBarcode";

export default class BarcodeHelper {
	public static checkDigits(value: string, leadingDigit?: number, trailingDigit?: number): boolean {
		let checkDigit = parseInt(value[value.length - 1]);

		let digitSum: number = 0;
		for (let i: number = 0; i < value.length - 1; i++) {
			digitSum += parseInt(value[i]) * ((i + 1) % 2 ? leadingDigit || 3 : trailingDigit || 1);
		}

		return checkDigit === (10 - (digitSum % 10)) % 10
	}

	public static async isCode39(value: string): Promise<boolean> {
		try {
			await bwipjs.toCanvas(document.createElement("canvas"), {
				bcid: PortalBarcodeFormat.code39,
				text: value
			});
		} catch (e: any) {
			return false;
		}

		let regexp: RegExp = /^[0-9A-Z\s\-$./+%]+$/;
		return regexp.test(value);
	}

	private static hasCodabarBoundary(value: string): boolean {
		let start: string = value[0];
		let end: string = value[value.length - 1];

		let boundariesCheck: RegExp = /^[*A-ETN]+$/;
		return boundariesCheck.test(start) || boundariesCheck.test(end);
	}

	public static checkCodabarBoundary(value: string): boolean {
		let start: string = value[0];
		let end: string = value[value.length - 1];

		if (BarcodeHelper.hasCodabarBoundary(value)) {
			return start === end;
		}

		return true;
	}

	public static async isCodabar(value: string): Promise<boolean> {
		try {
			await bwipjs.toCanvas(document.createElement("canvas"), {
				bcid: PortalBarcodeFormat.codabar,
				text: value
			});
		} catch (e: any) {
			return false;
		}

		let content: string = value;

		if (BarcodeHelper.hasCodabarBoundary(value)) {
			content = value.substr(1, value.length - 2);
		}

		let regexp: RegExp = /^[0-9$+\-:./]+$/;
		return regexp.test(content);
	}

	public static async isItf(value: string): Promise<boolean> {
		try {
			await bwipjs.toCanvas(document.createElement("canvas"), {
				bcid: PortalBarcodeFormat.itf,
				text: value
			});
		} catch (e: any) {
			return false;
		}

		let regexp: RegExp = /^[0-9]{14}$/;
		return regexp.test(value);
	}

	public static async isEan8(value: string): Promise<boolean> {
		try {
			await bwipjs.toCanvas(document.createElement("canvas"), {
				bcid: PortalBarcodeFormat.ean8,
				text: value
			});
		} catch (e: any) {
			return false;
		}

		let regexp: RegExp = /^[0-9]{8}$/;
		return regexp.test(value);
	}

	public static async isEan13(value: string): Promise<boolean> {
		try {
			await bwipjs.toCanvas(document.createElement("canvas"), {
				bcid: PortalBarcodeFormat.ean13,
				text: value
			});
		} catch (e: any) {
			return false;
		}

		let regexp: RegExp = /^[0-9]{13}$/;
		return regexp.test(value);
	}

	public static async isUpca(value: string): Promise<boolean> {
		try {
			await bwipjs.toCanvas(document.createElement("canvas"), {
				bcid: PortalBarcodeFormat.upca,
				text: value
			});
		} catch (e: any) {
			return false;
		}

		let regexp: RegExp = /^[0-9]{12}$/;
		return regexp.test(value);
	}
}